import { Button } from 'foundations-components/transitional/components/Button';
import { View } from 'foundations-components/transitional/components/View';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import RouterLink from 'ui-addon-react-router-dom/RouterLink';
import { useLocation } from 'react-router-dom';
import { getResultsPagePath, isOnResultsPage } from './hooks/useNavigateToResultsPage';
import { jsx as _jsx } from "react/jsx-runtime";
const HeaderButton = ({
  searchValue,
  onClick
}) => /*#__PURE__*/_jsx(Button, {
  block: true,
  paddingBlock: "200",
  paddingInline: "500",
  use: "unstyled",
  onClick: onClick,
  children: /*#__PURE__*/_jsx(View, {
    inlineSize: "100%",
    textAlign: "start",
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: 'academy-navigation-lib.ACPage.header.search.autocompleteResults.title.showResultsFor',
      options: {
        searchValue
      }
    })
  })
});
const HeaderLink = ({
  searchValue,
  onClick
}) => {
  const location = useLocation();
  const replace = isOnResultsPage(location.pathname);
  return /*#__PURE__*/_jsx(RouterLink, {
    onClick: onClick,
    replace: replace,
    to: getResultsPagePath(replace ? location.search : undefined, {
      search: searchValue
    }),
    use: "unstyled",
    children: /*#__PURE__*/_jsx(HeaderButton, {
      searchValue: searchValue
    })
  });
};
const SearchAutocompleteResultsHeader = ({
  searchValue,
  disableResultsNavigation = false,
  onClick
}) => {
  if (!searchValue) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    "data-test-id": "search-autocomplete-results-header",
    borderBlockEndStyle: "solid",
    borderBlockEndWidth: "100",
    borderBlockEndColor: "border-core-subtle",
    children: disableResultsNavigation ? /*#__PURE__*/_jsx(HeaderButton, {
      searchValue: searchValue,
      onClick: onClick
    }) : /*#__PURE__*/_jsx(HeaderLink, {
      searchValue: searchValue,
      onClick: onClick
    })
  });
};
export default SearchAutocompleteResultsHeader;